var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClear = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9974 0.666504C4.38906 0.666504 0.664062 4.3915 0.664062 8.99984C0.664062 13.6082 4.38906 17.3332 8.9974 17.3332C13.6057 17.3332 17.3307 13.6082 17.3307 8.99984C17.3307 4.3915 13.6057 0.666504 8.9974 0.666504ZM13.1641 11.9915L11.9891 13.1665L8.9974 10.1748L6.00573 13.1665L4.83073 11.9915L7.8224 8.99984L4.83073 6.00817L6.00573 4.83317L8.9974 7.82484L11.9891 4.83317L13.1641 6.00817L10.1724 8.99984L13.1641 11.9915Z",
    fill: "white",
    fillOpacity: 0.54
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClear);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_clear.54955520dbcfb5023940626c65bdc7cf.svg";